import RedirectMiddleware from '@/middleware/RedirectMiddleware';

export default [
    {
        path: '/register',
        name: 'register',
        beforeEnter: RedirectMiddleware,
        redirect: { name: 'register.email' },
        components: {
            // route level code-splitting. This generates a separate chunk (register.[hash].js) for this route which is
            // lazy-loaded when the route is visited.
            default: () => import(/* webpackChunkName: "register" */ '@/views/Register'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
        children: [
            {
                path: 'account',
                name: 'register.account',
                beforeEnter: RedirectMiddleware,
                component: () => import(/* webpackChunkName: "register" */ '@/views/register/Account'),
            },
            {
                path: 'delivery',
                name: 'register.delivery',
                component: () => import(/* webpackChunkName: "register" */ '@/views/register/Delivery'),
            },
            {
                path: 'card-details',
                name: 'register.card-details',
                component: () => import(/* webpackChunkName: "register" */ '@/views/register/CardDetails'),
            },
            {
                path: 'email',
                name: 'register.email',
                component: () => import(/* webpackChunkName: "register" */ '@/views/register/GetEmail'),
            },
            {
                path: 'subscription-details',
                name: 'register.subscription-details',
                component: () => import(/* webpackChunkName: "register" */ '@/views/register/SubscriptionDetails'),
            },
            {
                path: 'delivery-details',
                name: 'register.delivery-details',
                component: () => import(/* webpackChunkName: "register" */ '@/views/register/DeliveryDetails'),
            },
            {
                path: 'your-details',
                name: 'register.your-details',
                component: () => import(/* webpackChunkName: "register" */ '@/views/register/YourDetails'),
            },
            {
                path: 'payment-details',
                name: 'register.payment-details',
                // component: () => import(/* webpackChunkName: "register" */ '@/views/register/PaymentDetails'),
                component: () => import(/* webpackChunkName: "register" */ '@/components/forms/register/PaymentScreen'),
            },
        ],
    },
];
